async function loadPageComponent(program_ns) {
  try {
    const component = await import(`../pages/${program_ns.toLowerCase()}/${program_ns.toLowerCase()}`);
    return component.default;
  } catch (error) {
    console.error(`Error loading page component for ${program_ns}:`, error);
    return () => <div>Component not found</div>;
  }
}

export default loadPageComponent;
